import { ApiResponse } from "apisauce";
import { IPagination } from "src/models/extensions/withPagination";
import { IAuthInfo, IResponseSnapshot } from '../../models';
import { Api } from "../api/api";
import { getGeneralApiProblem } from "../api/api-problem";
import {
  TGetAuthInfoResult,
  TGetAuthInfosResult,
  TUpdateAuthInfoResult
} from "./AuthInfoTypes";

  /**
  * # AuthInfo Api 서비스
  * 
  * 서비스의 설명을 작성하세요.
  * 
  * ## 사용방법
  * 
  * ```ts
  * const service = new AuthInfoApi();
  * 
  * ```
  */
 export class AuthInfoApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  private BASE_URL = '/authHistory';

  async getAuthInfoList(paging:IPagination): Promise<TGetAuthInfosResult> {
    try {
      const url = `${this.BASE_URL}`;
      const params = { size: paging.size, page: paging.page-1 };
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  

      const authInfoList: IAuthInfo[] = response.data.data;
      const pagination: IPagination = response.data.pagination;
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: "ok", authInfoList, pagination, responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }


  async getAuthInfo(userSid:number): Promise<TGetAuthInfoResult> {
    try {
      const url = `${this.BASE_URL}/${userSid}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  

      const authInfo: IAuthInfo = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: "ok", authInfo, responseInfo:responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  async updateAuthInfo(userSid:number, authHistory:any): Promise<TUpdateAuthInfoResult> {
    try {
      const url = `${this.BASE_URL}/${userSid}`;
      const payload = {
        ...authHistory
      };
      const response: ApiResponse<any> = await this.api.apisauce.put( url, payload );
      const responseInfo: IResponseSnapshot = response.data;

      const authInfo: IAuthInfo = response.data.data;
      return { kind: "ok", authInfo, responseInfo: responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

}